import React, { useState, useEffect, useContext } from 'react';
import { Redirect, useHistory } from "react-router-dom";
import UserService from '../../services/UserService';
import UserContext from '../../contexts/UserContext';
import AuthService from '../../services/auth.services';
import FriendsService from '../../services/FriendService';
import Layout from '../LayoutComponent';
import { testScript } from '../../js/script';
import settings from '../../services/Settings';
import fileStorage from '../../config/fileStorage';

function FriendsComponent() {
	let history = useHistory();

	const { user } = useContext(UserContext)

	const [refresh, setRefresh] = useState([]);


	// const []

	const [allUser, setAllUser] = useState([]);
	const [friendsList, setFriendsList] = useState([]);
	const [friendsCount, setFriendsCount] = useState();
	const [searchedUser, setSearchedUser] = useState([]);

	const [showComp, setShowComp] = useState("members");

	const [following, setFollowing] = useState([]);
	const [followingCount, setFollowingCount] = useState([]);
	const [searchedFollowing, setSearchedFollowing] = useState([]);

	const [followers, setFollowers] = useState([]);
	const [followersCount, setFollowersCount] = useState([]);
	const [searchedFollowers, setSearchedFollowers] = useState([]);

	const [friendRequestSent, setFriendRequestSent] = useState([]);
	const [searchedFriendRequestSent, setSearchedFriendRequestSent] = useState([]);

	const [friendRequestRecieved, setFriendRequestRecieved] = useState([]);
	const [searchedFriendRequestRecieved, setSearchedFriendRequestRecieved] = useState([]);


	const addFriendsId = (uid, fid) => {
		FriendsService.addFriends(uid, fid).then(res => {
			window.location.reload();
		})
	}

	const removeFriend = (uid, fid) => {
		FriendsService.removeFriends(uid, fid).then(res => {
			setRefresh(res.data)
		})
	}

	const handleSearchedFollowing = (event) => {
		if (event.target.value === "") {
			setSearchedFollowing(following)
		} else {
			let temp = []
			following.map(u => {
				const email = u.email.toLowerCase()
				const firstname = u.firstName.toLowerCase()
				const lastname = u.lastName.toLowerCase()
				const searchedvalue = event.target.value.toLowerCase()
				
				if (email.includes(searchedvalue) || firstname.includes(searchedvalue) || lastname.includes(searchedvalue)) {
					temp.push(u)
				}
			})
			setSearchedFollowing(temp)
		}

	}


	const handleSearchedFollowers = (event) => {
		if (event.target.value === "") {
			setSearchedFollowers(followers)
		} else {
			let temp = []
			followers.map(u => {
				const email = u.email.toLowerCase()
				const firstname = u.firstName.toLowerCase()
				const lastname = u.lastName.toLowerCase()
				const searchedvalue = event.target.value.toLowerCase()
				
				if (email.includes(searchedvalue) || firstname.includes(searchedvalue) || lastname.includes(searchedvalue)) {
					temp.push(u)
				}
			})
			setSearchedFollowers(temp)
		}
	}

	const acceptFriendRequest = (uid, fid) => {
		FriendsService.acceptRequest(uid, fid).then(res => {
			setRefresh(res.data)
		})
	}

	const declineFriendRequest = (uid, fid) => {
		FriendsService.declineRequest(uid, fid).then(res => {
			setRefresh(res.data)
		})
	}

	const unsendFriendRequest = (uid, fid) => {
		FriendsService.unsendRequest(uid, fid).then(res => {
			setRefresh(res.data)
		})
	}

	const sendFriendRequest = (uid, fid) => {
		FriendsService.sendRequest(uid, fid).then(res => {
			setRefresh(res.data)
		})
	}



	const handleFollow = (uid) => {
		UserService.follow(user.email, uid).then(res => {
			setRefresh(res.data)
		})
	}

	const handleUnfollow = (uid) => {
		UserService.unfollow(user.email, uid).then(res => {
			setRefresh(res.data)
		})
	}

	const handleShowComp = () => {
		if (showComp === "members") {
			return FcomponentFunction()
		} else if (showComp === "followers") {
			return FollowersComponentFunction()
		} else if (showComp === "following") {
			return FollowingComponentFunction()
		} else if (showComp === "friendRequestSent") {
			return FriendRequestSentComponentFunction()
		} else if (showComp === "friendRequestRecieved") {
			return FriendRequestRecievedComponentFunction()
		}
		else {
			return "<h1>None To Show</h1>"
		}
	}

	const FcomponentFunction = () => {
    return (<div className="tab-content">
        <div className="friends-search-container grp-search">
            {/* <i className="las la-search"></i> */}
			<input className="friend-search" type="text" id="header-search" placeholder="Search Friends" name="s" onChange={handleSearchedUser} />
        </div>
        <div className="tab-pane active fade show " id="frends">
            {/* <div style={{ contentAlign: 'center', textAlign: 'center', paddingTop: '15px' }}>
                {(friendsList.length > 0) ? <p style={{ marginBottom: '5px', fontWeight: 'medium', fontSize: '24px', color: '#646464' }}>Your Friends!</p>:
                <p style={{ fontWeight: 'medium', fontSize: '18px', color: '#646464' }}>There are no Friends!</p>}
            </div> */}
            <ul className="nearby-contct" style={{marginTop:'15px'}}>
                {searchedUser&&searchedUser.length>0?
				searchedUser.map(
                    userM =>
                        <li key={userM.id} className="friends-card grp">
                            <div className="grid-container">
                                {/* <figure> */}
                                <div className="item1">
                                    <a href={`/profile/${userM.email}`} title={`${userM.email}`}><img style={{objectFit:'cover'}} src={fileStorage.baseUrl+userM.profilePicturePath} alt="" /></a>
                                    {/* </figure> */}
                                </div>
                                {/* <div className="  "> */}
                                <div className="item2">
                                    <p className="nameTag"><a href={`/profile/${userM.email}`} title={`${userM.email}`}>{`${userM.firstName} ${userM.lastName}`}</a></p>
									<div style={{fontSize:'12px',paddingTop:'5px'}}>10 Mutual friends</div>

									{/* <button className="friends-button" onClick={() => unsendFriendRequest(user.id, userM.id)}>Request Sent</button> */}
									
								</div>
                                <div className="item4">
								{
                                    (user.id !== userM.id) ?
                                        (!friendsList.some(el => el.id === userM.id)) ?
                                            friendRequestRecieved.some(el => el.id === userM.id)
                                                ?
                                                <>
                                                     <div className="">
                                                            <a href="#!" title="#" className="button" style={{ color: "#000000",background:'#EAEAEA', fontSize:'12px' }} data-ripple onClick={() => acceptFriendRequest(user.id, userM.id)}>Accept Request</a>
														
                                                        </div>
                                                        {/* <div className="item3">
                                                            <p><a style={{ display: "block", float: "right", color: "#fff",background:'#033347',fontSize:'12px' }} href="#" onClick={() => declineFriendRequest(user.id, userM.id)}>Decline Friend Request</a></p>
                                                            <br></br>
                                                            <br></br>
                                                        </div>  */}
                                                </>
                                                :
                                                friendRequestSent.some(el => el.id === userM.id)
                                                    ?
                                                    
                                                       <a href="#!"  className="button" style={{ color: "#fff",background:'#033347',fontSize:'12px' }} data-ripple onClick={() => unsendFriendRequest(user.id, userM.id)}>Unsend Request</a> 
                                                   
                                                    :
                                                   
                                                         <a href="#!"  className="button" style={{ color: "#000000",background:'#EAEAEA', fontSize:'12px' }} data-ripple onClick={() => sendFriendRequest(user.id, userM.id)}>Send Request</a> 
                                                    
                                            :
                                            <>
                                                
                                                     <a href="#"  style={{ color: "#fff",background:'#033347' }}
													 
													 className="add-butn more-action" data-ripple onClick={() => removeFriend(user.id, userM.id)}>Unfriend</a> 
                                                
                                                
                                            </>
                                        :
                                        <div >
                                            {/* <p style={{ float: "right" }}>Your own profile</p> */}
                                        </div>
                                }
								
                                </div>
                               
								{/* <div className="item6">
                                     <span>Engr</span> 
                                    <i style={{ float: "right", fontSize: 35 }} className="las la-ellipsis-v"></i>
                                </div> */}
                               
                                {
                                    (user.id !== userM.id) ?
                                        (!following.some(el => el.id === userM.id)) ?
                                            <div className="item7">
                                                {/* <p><a className="button3" style={{ backgroundColor: "#0009b7", color: "#ffffff"}} href="#!" onClick={() => handleFollow(userM.id)} >Follow</a></p> */}
                                            </div>
                                            :
                                            <div className="item7">
                                                {/* <p><a className="button3" style={{ backgroundColor: "#e25555", color: "#ffffff"}} href="#!" onClick={() => handleUnfollow(userM.id)}>Unfollow</a></p> */}
                                            </div>
                                        :
                                        null
                                }


                                {/* </div> */}
                            </div>
                        </li>
                )
				:<div style={{display:'flex',justifyContent:'center',alignItems:'center' ,width:'100%',minHeight:'100px'}}><h2>No Friends</h2></div>}
            </ul>
            <div className="lodmore"><button className="btn-view btn-load-more" /></div>
        </div>
    </div>)
}

const FollowingComponentFunction = () => {
    return (
        <div className="tab-content">
            <div className="friends-search-container grp-search">
                {/* <i className="las la-search"></i> */}
				<input className="friend-search" type="text" id="header-search" placeholder="Search Following" name="s" onChange={handleSearchedFollowing} />
            </div>
            <div className="tab-pane active fade show " id="following">
                <ul className="nearby-contct" style={{marginTop:'15px'}}>
                    {searchedFollowing.map(
                        userM =>
                            <li key={userM.id} className="friends-card grp">
                                <div className="grid-container">
                                    {/* <div className="nearly-pepls"> */}
                                    {/* <figure> */}
                                    <div className="item1">
                                        <a href={`/profile/${userM.email}`} title={`${userM.email}`}><img src={fileStorage.baseUrl+userM.profilePicturePath} alt="" /></a>
                                        {/* </figure> */}
                                    </div>
                                    {/* <div className="  "> */}
                                    <div className="item2">
                                        <p className="nameTag"><a href={`/profile/${userM.email}`} title={`${userM.email}`}>{`${userM.firstName} ${userM.lastName}`}</a></p>
										<div  style={{fontSize:'12px',paddingTop:'5px'}}>10 Mutual friends</div>
									</div>
                                    <div className="item4">
										<a href="#"  className="add-butn more-action" data-ripple onClick={() => handleUnfollow(userM.id)}>unfollow</a>
									</div>
                                    {/* <div className="item6">
                                        {/* <span>Engr</span> 
                                        <i style={{ float: "right", fontSize: 35 }} className="las la-ellipsis-v"></i>
                                    </div> */}
                                    {/* <div className="pepl-info">
                                            <h4><a href={`/profile/${userM.email}`} title={`${userM.email}`}>{`${userM.firstName} ${userM.lastName}`}</a></h4>
                                            <p><a href={`/profile/${userM.email}`} title={`${userM.email}`}>{`${userM.email}`}</a></p>
                                            <span>Engr</span>
                                            <a href="#" title="#" className="add-butn more-action" data-ripple onClick={() => handleUnfollow(userM.id)}>unfollow</a>
                                        </div> */}
                                    {/* </div> */}
                                </div>
                            </li>
                    )}
                </ul>
                <div className="lodmore"><button className="btn-view btn-load-more" /></div>
            </div>
        </div >
    );
}

const FollowersComponentFunction = () => {
    return (
        <div className="tab-content">
            <div className="friends-search-container grp-search">
                {/* <i className="las la-search"></i> */}
				<input className="friend-search" type="text" id="header-search" placeholder="Search Followers" name="s" onChange={handleSearchedFollowers} />
            </div>
            {/* <input type="text" id="header-search" placeholder="Search Followers" name="s" onChange={handleSearchedFollowers} /> */}
            <div className="tab-pane active fade show " id="following">
                <ul className="nearby-contct" style={{marginTop:'15px'}}>
                    {searchedFollowers.map(
                        userM =>
                            <li key={userM.id} className="friends-card grp">
                                <div className="grid-container">
                                    {/* <div className="nearly-pepls"> */}
                                    {/* <figure> */}
                                    <div className="item1">
                                        <a href={`/profile/${userM.email}`} title="#"><img src={fileStorage.baseUrl+userM.profilePicturePath} alt="" /></a>
                                        {/* </figure> */}
                                    </div>
                                    {/* <div className="  "> */}
                                    <div className="item2">
                                        <p className="nameTag"><a href={`/profile/${userM.email}`} title={`${userM.email}`}>{`${userM.firstName} ${userM.lastName}`}</a></p>
										{/* <button className="friends-button">Request Sent</button> */}
										<div style={{fontSize:'12px',paddingTop:'5px'}}>10 Mutual friends</div>
										
										
                                    </div>
                                    <div className="item4">
										<a href="#"  className="add-butn more-action" data-ripple onClick={() => handleUnfollow(userM.id)}>unfollow</a>
									</div>
                                     {/* <div className="pepl-info">
                                            <h4><a href={`/profile/${userM.email}`} title={`${userM.email}`}>{`${userM.firstName} ${userM.lastName}`}</a></h4>
                                            <p><a href={`/profile/${userM.email}`} title={`${userM.email}`}>{`${userM.email}`}</a></p>
                                            <span>Engr</span>
                                          
                                        </div>  */}
                                    {/* </div> */}
                                </div>
                            </li>


                        // <li key={userM.id} className="friends-card">
                        // 	<div className="grid-container">
                        // 		<div className="nearly-pepls">
                        // 			<figure>
                        // 				<a href={`/profile/${userM.email}`} title="#"><img src="https://wallpaperaccess.com/full/2213424.jpg" alt="" /></a>
                        // 			</figure>
                        // 			<div className="pepl-info">
                        // 				<h4><a href={`/profile/${userM.email}`} title={`${userM.email}`}>{`${userM.firstName} ${userM.lastName}`}</a></h4>
                        // 				<p><a href={`/profile/${userM.email}`} title={`${userM.email}`}>{`${userM.email}`}</a></p>
                        // 				{/* <span>Engr</span> */}
                        // 				{/* <a href="#" title="#" className="add-butn more-action" data-ripple onClick={() => }>unfriend</a> */}

                        // 			</div>
                        // 		</div>
                        // 	</div>
                        // </li>
                    )}
                </ul>
                <div className="lodmore"><button className="btn-view btn-load-more" /></div>
            </div>
        </div>
    );
}



const FriendRequestSentComponentFunction = () => {
	return (
		<div className="tab-content">
			<input type="text" id="header-search" placeholder="Search Followers" name="s" onChange={handleSearchedFollowers} />
			<div className="tab-pane active fade show " id="following">
				<ul className="nearby-contct" style={{marginTop:'15px'}}>
					{friendRequestSent.map(
						userM =>
							<li key={userM.id}>
								<div className="nearly-pepls">
									<figure>
										<a href={`/profile/${userM.email}`} title={`${userM.email}`}><img src="https://wallpaperaccess.com/full/2213424.jpg" alt="" /></a>
									</figure>
									<div className="pepl-info">
										<h4><a href={`/profile/${userM.email}`} title={`${userM.email}`}>{`${userM.firstName} ${userM.lastName}`}</a></h4>
										<p><a href={`/profile/${userM.email}`} title={`${userM.email}`}>{`${userM.email}`}</a></p>
										{/* <span>Engr</span> */}
										<a href="#" title="#" className="add-butn more-action" data-ripple onClick={() => {}}>unfriend</a>

									</div>
								</div>
							</li>
					)}
				</ul>
				<div className="lodmore"><button className="btn-view btn-load-more" /></div>
			</div>
		</div>
	);
}

const FriendRequestRecievedComponentFunction = () => {
	return (
		<div className="tab-content">
			<input type="text" id="header-search" placeholder="Search Followers" name="s" onChange={handleSearchedFollowers} />
			<div className="tab-pane active fade show " id="following">
				<ul className="nearby-contct" style={{marginTop:'15px'}}>
					{friendRequestRecieved.map(
						userM =>
							<li key={userM.id}>
								<div className="nearly-pepls" key={userM.id}>
									<figure>
										<a href={`/profile/${userM.email}`} title={`${userM.email}`}><img src="https://wallpaperaccess.com/full/2213424.jpg" alt="" /></a>
									</figure>
									<div className="pepl-info">
										<h4><a href={`/profile/${userM.email}`} title={`${userM.email}`}>{`${userM.firstName} ${userM.lastName}`}</a></h4>
										<p><a href={`/profile/${userM.email}`} title={`${userM.email}`}>{`${userM.email}`}</a></p>
										<span>Engr</span>
										<a href="#" title="#" className="add-butn more-action" data-ripple onClick={() => {}}>unfriend</a>

									</div>
								</div>
							</li>
					)}
				</ul>
				<div className="lodmore"><button className="btn-view btn-load-more" /></div>
			</div>
		</div>
	);
}

const getAllUser = async () => {
	await UserService.getUsers().then(res => {
		setAllUser(res.data)
		allUser.map((Auser)=>{
			if(Auser.id==user.id){
				setFriendsCount(Auser.numberOfFriends);
				setFollowingCount(Auser.numberOfFollowing);
				setFollowersCount(Auser.numberOfFollowers);

			}
		})
	})
}

const getFriendsList = async () => {
	const jwtUser = AuthService.getCurrentUser();
	if (!jwtUser || !jwtUser.username) return;
	await FriendsService.getFriends(jwtUser.username).then(res => {
		setFriendsList(res.data)
		setSearchedUser	(res.data)
	})
}

const getAllFollowing = async () => {
	const jwtUser = AuthService.getCurrentUser();
	if (!jwtUser || !jwtUser.username) return;
	try {
		const res = await UserService.getFollowing(jwtUser.username);
		const data = Array.isArray(res?.data) ? res.data : [];
		setFollowing(data)
		setSearchedFollowing(data)
	} catch (error) {
		const status = error?.response?.status;
		if (status === 404) {
			setFollowing([])
			setSearchedFollowing([])
			return;
		}
		console.warn('FriendsComponent.getAllFollowing failed:', error);
		setFollowing([])
		setSearchedFollowing([])
	}
}


const getAllFollowers = async () => {
	const jwtUser = AuthService.getCurrentUser();
	if (!jwtUser || !jwtUser.username) return;
	try {
		const res = await UserService.getFollowers(jwtUser.username);
		const data = Array.isArray(res?.data) ? res.data : [];
		setFollowers(data)
		setSearchedFollowers(data)
	} catch (error) {
		const status = error?.response?.status;
		if (status === 404) {
			setFollowers([])
			setSearchedFollowers([])
			return;
		}
		console.warn('FriendsComponent.getAllFollowers failed:', error);
		setFollowers([])
		setSearchedFollowers([])
	}
}

const getAllFriendRequestSent = async () => {
	const jwtUser = AuthService.getCurrentUser();
	if (!jwtUser || !jwtUser.username) return;
	await UserService.getFriendRequestSent(jwtUser.username).then(res => {
		setFriendRequestSent(res.data)
	})
}

const getAllFriendRequestRecieved = async () => {
	const jwtUser = AuthService.getCurrentUser();
	if (!jwtUser || !jwtUser.username) return;
	await UserService.getFriendRequestRecieved(jwtUser.username).then(res => {
		setFriendRequestRecieved(res.data)
	})
}

const handleSearchedUser = (event) => {
	if (event.target.value === "") {
		setSearchedUser(friendsList)
	} else {
		let temp = []
		friendsList.map(u => {
			const email = u.email.toLowerCase()
			const firstname = u.firstName.toLowerCase()
			const lastname = u.lastName.toLowerCase()
			const searchedvalue = event.target.value.toLowerCase()
			if (email.includes(searchedvalue) || firstname.includes(searchedvalue) || lastname.includes(searchedvalue)) {
				temp.push(u)
			}
		})
		setSearchedUser(temp)
	}

}

useEffect(() => {
	getAllUser()
	getFriendsList()
	getAllFollowing()
	getAllFollowers()
	getAllFriendRequestSent()
	getAllFriendRequestRecieved()

}, [showComp, refresh])

useEffect(() => {
	testScript()
}, [])


return (
	<Layout user={user}>
		<div className="">
			<div className="central-meta swap-pg-cont">
				<div className="frnds">
					{/* <ul className="nav nav-tabs"> */}
					<div >
						<p className="Friends-Title">Friends</p>
						<i style={{ float: "right", fontSize: 20 }} className="fas fa-ellipsis-v"></i>
					</div>
					<div className="navContent">

						<ul className="nav nav-pills swap-page-nav" role="tablist">
							
							
							<li className="nav-item"style={{justifyContent:'flex-start'}} >
                  				<div className="all" onClick={() => setShowComp("members")}>
									<span style={{ cursor: 'pointer' }}  >
										<span style={{  padding: '5px' }}> 
											<i className="las la-user" style={{fontSize:'20px'}}></i>
										</span>
										Friends 
										<a className='numberCircle'>{`${friendsList&&friendsList.length!=='undefined'?friendsList.length:''}`}</a>
									</span>
								</div>
								{/* <span>{`${allUser.length}`}</span> */}
							</li>


							<li className="nav-item" style={{justifyContent:'center'}}>
                  				<div className="my" onClick={() => setShowComp("following")}>
									<span style={{ cursor: 'pointer' }} > 
										<span style={{  padding: '5px' }}> 
											<i className="las la-user-cog" style={{fontSize:'20px'}}></i> 
										</span>
										Following <a className='numberCircle'>{`${following&&following.length?following.length:'0'}`}</a>
									</span>
									</div>
								{/* <span>{`${following.length}`}</span> */}
							</li>

							
							<li className="nav-item" style={{justifyContent:'flex-end'}}>
                  				<div className="new" onClick={() => setShowComp("followers")}>
									<span style={{ cursor: 'pointer' }} >
										<span style={{  padding: '5px' }}> 
											<i className="las la-user-tag" style={{fontSize:'20px'}}></i> 
										</span>
										Followers
											<a className='numberCircle'>{`${followers&&followers.length?followers.length:'0'}`}</a>
									</span>
								</div>	
									{/* <span>{`${followers.length}`}</span> */}
							</li>
						</ul>
					</div>

					{/* <li className="nav-item"><a className="" href="#!" onClick={() => setShowComp("members")}
														data-toggle="tab">Members</a> <span>{`${allUser.length}`}</span></li>
													<li className="nav-item"><a className="" href="#!" onClick={() => setShowComp("following")}
														data-toggle="tab">Following</a> <span>{`${following.length}`}</span></li>
													<li className="nav-item"><a className="" href="#!" onClick={() => setShowComp("followers")}
														data-toggle="tab">Followers</a> <span>{`${followers.length}`}</span></li> */}
					{/* <li className="nav-item"><a className="" href="#!" onClick={() => setShowComp("friendRequestSent")}
														data-toggle="tab">Request Sent</a><span>{`${friendRequestSent.length}`}</span></li> */}
					{/* <li className="nav-item"><a className="" href="#!" onClick={() => setShowComp("friendRequestRecieved")}
														data-toggle="tab">Request Recieved</a><span>{`${friendRequestRecieved.length}`}</span></li> */}
					{/* </ul> */}
					{/* <br/> */}
					{handleShowComp()}
				</div>
			</div>
			
		</div>
	</Layout>
);
}
export default FriendsComponent;